<ng-container *ngIf="!disbleRoutes">
  <app-header *ngIf="!router.url.includes('conference-room')"></app-header>

  <router-outlet></router-outlet>
  <div (click)="scrollToTop()" class="btn scroll-to-top" *ngIf="showBtn$ | async" >
    <i class="fa fa-arrow-up" aria-hidden="true"></i>
  </div>
  <div class="footer-fixed">
    <app-footer *ngIf="!router.url.includes('conference-room')"></app-footer>
  </div>
  <ngx-ui-loader></ngx-ui-loader>
</ng-container>
<ng-container *ngIf="disbleRoutes">
  <div class="container text-center fill-height">
    <div class="row hello">
      <div class="col">
        <img src="../assets/Logo.png" style="margin-bottom: 20px" />
        <h5>
          {{roleName}} cannot access this application.please go back to
          <a style="color: #4c3180" href="{{wellness}}"
            >{{brandData?.brandName}} Wellness</a
          >
        </h5>
      </div>
    </div>
  </div>
</ng-container>
